export function setUserProfile( profile ) {
  return {
    type: 'SET_USER_PROFILE',
    payload: profile
  };
}

export function clearUserProfile() {
  return {
    type: 'CLEAR_USER_PROFILE',
    payload: ''
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/user.js